
setTimeout(() => {
  labels = document.querySelectorAll("label");
  var inputs = document.querySelectorAll(
    "#RegisterForm-FirstName, #RegisterForm-LastName, #RegisterForm-email, #RegisterForm-password, .rendered-form input"
  );
  var filteredLabels = Array.from(labels).filter(
    (label) => !label.classList.contains("field__label")
  );
  console.log(filteredLabels);
  console.log(inputs);
  function updateLabelStyle(input, label) {
    if (input.value.trim() !== "" || input === document.activeElement) {
      label.style.top = ".5rem";
      label.style.left = "calc(var(--inputs-border-width) + 2rem)";
      label.style.fontSize = "1rem";
      label.style.letterSpacing = ".04rem";

      input.style.padding = "2.2rem 1.5rem .8rem 2rem";
      input.style.margin = "var(--inputs-border-width)";
    } else {
      label.style.top = "calc(1rem + var(--inputs-border-width))";
      label.style.left = "calc(var(--inputs-border-width) + 2rem)";
      label.style.fontSize = "1.6rem";
      label.style.letterSpacing = ".1rem";

      input.style.padding = "1.5rem";
      input.style.margin = "var(--inputs-border-width)";
    }
  }

  inputs.forEach((input, index) => {
    input.addEventListener("input", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
    input.addEventListener("focus", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
    input.addEventListener("blur", () =>
      updateLabelStyle(input, filteredLabels[index])
    );
  });
},300);
let timeBack = 10;
const handleF = () => {
  const target = $("fieldset");
  if (target.length > 0) {
    $(target).on("change", () => {
      setTimeout(() => {
        const urlParams = new URLSearchParams(
          new URL(window.location.href).search
        );
        const variantValue = urlParams.get("variant");
        console.log(variantValue);
        BSS_B2B.cp.changeProductPrice(
          JSON.parse($("#bss-b2b-store-data").html()),
          "[bss-b2b-variant-id]",
          false,
          false,
          variantValue
        );
      }, 200);
    });
  } else if (timeBack-- > 0) {
    setTimeout(handleF, 300);
  }
};
handleF();
